export default __webpack_public_path__ + "static/media/watermarkMult.5aa711db.png";